const resetPassword = {
  stepProgress: "Step {step}/{total}",
  step1: {
    title: "Reset Password",
    subtitle:
      "Enter your registered email address & temporary password sent to {email} to reset password.",
    email: "Email Address",
    emailPlaceholder: "Enter email",
    temporaryPassword: "Temporary Password",
    temporaryPasswordPlaceholder: "Enter temporary password",
  },
  step2: {
    title: "Reset Password",
    subtitle: "Choose a new password for {email}.",
    currentPassword: "Current Password",
    currentPasswordPlaceholder:
      "Enter your temporary or current password",
    newPassword: "New Password",
    newPasswordPlaceholder: "Enter new password",
    confirmPassword: "Confirm Password",
    confirmPasswordPlaceholder: "Confirm new password",
    confirmMatchAria: "Passwords match",
    rules: {
      length: "Must be at least 8 characters long.",
      complexity:
        "Includes one upper-case, one lower-case, one number, & one special character.",
    },
  },
  success: {
    title: "Password reset successfully!",
    description:
      "Please login using your registered email and new password.",
  },
  next: "Next",
  reset: "Reset Password",
  backToLogin: "Back to Login",
};

export default resetPassword;
